document.addEventListener('DOMContentLoaded', () => {
  // For every product card on the page
  document.querySelectorAll('.card').forEach((card) => {
    const productRoot = card.closest('product-card') || card; // theme-safe root
    const wrap = card.querySelector('.bd-sample-order-wrap'); // your sample wrapper
    const sampleBtn = wrap ? wrap.querySelector('.js-sample-order') : null;

    // Helpers
    const getLinks = () => productRoot.querySelectorAll('.js-prod-link');
    const setLinksVariant = (variantId) => {
      getLinks().forEach((link) => {
        try {
          const u = new URL(link.href, location.origin);
          u.searchParams.set('variant', String(variantId));
          link.href = u.pathname + u.search; // keep relative path
        } catch {
          // Fallback if link.href can't be parsed (unlikely)
          const base = link.href.split('?variant=')[0];
          link.href = `${base}?variant=${variantId}`;
        }
      });
    };

    const setSampleVariant = (variantId) => {
      if (!wrap) return;
      wrap.dataset.lastVariantId = String(variantId); // cache for click handler
      if (sampleBtn) sampleBtn.dataset.variantId = String(variantId);
    };

    // Resolve variant id from a changed control
    const resolveVariantIdFromControl = (el) => {
      // .opt-btn radios: prefer data-variant-id, else value on a dataset
      if (el && el.matches('.opt-btn')) {
        return el.dataset.variantId || el.value || el.getAttribute('value') || null;
      }
      // <select name="id"> (some themes)
      if (el && el.matches('select[name="id"]')) {
        return el.value || null;
      }
      // <input type="radio" name="id">
      if (el && el.matches('input[name="id"]')) {
        return el.value || null;
      }
      // Label carrying dataset
      const label = el && el.closest('label');
      if (label && label.dataset && label.dataset.variantId) {
        return label.dataset.variantId;
      }
      return null;
    };

    // 1) RADIO SWATCHES
    card.querySelectorAll('.opt-btn').forEach((swatch) => {
      // Some themes use click, others fire change — listen to both
      const handler = () => {
        const variantId = resolveVariantIdFromControl(swatch);
        if (!variantId) return;
        setLinksVariant(variantId);
        setSampleVariant(variantId);

        // Optional: update small UI bits if you have them
        const titleEl = card.querySelector('.js-variant-title');
        if (titleEl) titleEl.textContent = swatch.value || swatch.dataset.value || titleEl.textContent;

        const skuEl = card.querySelector('.js-variant-sku');
        if (skuEl) skuEl.textContent = swatch.closest('label')?.dataset?.sku || swatch.dataset.sku || skuEl.textContent;
      };
      swatch.addEventListener('change', handler);
      swatch.addEventListener('click', handler);
    });

    // 2) SELECT-BASED PICKERS (either variant id or options)
    const idSelect = card.querySelector('select[name="id"]');
    if (idSelect) {
      idSelect.addEventListener('change', () => {
        const variantId = resolveVariantIdFromControl(idSelect);
        if (!variantId) return;
        setLinksVariant(variantId);
        setSampleVariant(variantId);
      });
    }

    // 3) INPUT RADIO FOR name="id" (some themes render these)
    card.querySelectorAll('input[type="radio"][name="id"]').forEach((inp) => {
      inp.addEventListener('change', () => {
        const variantId = resolveVariantIdFromControl(inp);
        if (!variantId) return;
        setLinksVariant(variantId);
        setSampleVariant(variantId);
      });
    });

    // 4) INITIALIZE from link ?variant= if present (page load)
    (() => {
      const firstLink = getLinks()[0];
      if (!firstLink) return;
      try {
        const u = new URL(firstLink.href, location.origin);
        const vid = u.searchParams.get('variant');
        if (vid) setSampleVariant(vid);
      } catch {
        const m = firstLink.href.match(/[?&]variant=(\d+)/);
        if (m) setSampleVariant(m[1]);
      }
    })();
  });
});
